import React, { Suspense, Component } from 'react'
import { connect } from 'react-redux';
import BackIcon from '../assets/images/icons/mobiles/currentaccount_icon@3x.png';
import { getSafe } from '../helpers/global';
import classnames from 'classnames';
import Spinner from '@/components/Spinner/LoadingSpinner';
import '../assets/styles/core/mobile-sublayout.scss';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import enquiryIcon from '../assets/images/icons/mobiles/cashmanage_icon_enquiry@2x.png'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';

class MobileSubLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            closeall:false,
            step:0,
            fail:false
        }
        props.innerRef && props.innerRef(this)
    }
    render() {
        const { language, title, children , theme , isfundmanage, isExchangeInstruction,stockCode,name,layoutStyle} = this.props;
        const { isOpen , step , fail} = this.state;
        return (
            <div className={classnames('mobile-sub-layout-container', `mobile-sub-layout-container-${iTradeEnv.company}`,isOpen && 'mobile-sub-layout-open' , 'theme-'+ theme  )}>
                <div className="sub-layout">
                    <header className='header'>
                        <img className='back-icon' src={BackIcon} alt="arrow_icon" onClick={this.closeLayout} />
                        <div className="title">
                            { title ? getSafe(() => language[title], title) : ''}
                            {name ? name :''}
                            { stockCode ? (<div style={{fontSize:"14px",display:"flex",justifyContent:"center"}} >{stockCode}</div>) : ''}
                        </div>
                        { isfundmanage && <div className="fundmanage-enquiry" onClick={this.handleOpenCashDWenquiry}>
                            <img src={enquiryIcon} />
                            {getSafe(() => language.mobile_cash_dw_enquiry)}
                        </div>}
                        { isExchangeInstruction && <div className="fundmanage-enquiry" onClick={this.handleOpenExchangeRecord}>
                             <img src={enquiryIcon} />
                            {getSafe(() => language.mobile_exchange_record)}
                        </div>}
                    </header>
                    <div className="content">
                    <Suspense fallback={<Spinner />}>
                        {React.cloneElement(children, { ...this.props, closeLayout: this.closeLayout , closeAllBox: this.closeAllBox , riseStep :this.riseStep , setStep:this.setStep, step, fail})}
                    </Suspense>
                    </div>
                </div>
            </div>
        )
    }

    closeLayout = () => {
        const amendcolse = this.props.children.props.mode==='amend' && this.state.step === 4 && this.props.close
        const cancelcolse = this.props.children.props.mode==='cancel' && this.state.step === 3 && this.props.close
        if((this.props.children.props.mode==="A" || this.props.children.props.mode==="MA" || this.props.children.props.mode==='MO')  && this.state.step !==0 && this.state.step !==5){
            this.getBackStep()
        }else if((this.props.children.props.mode==='reply' || this.props.children.props.mode==='amend') && this.state.step !==2 && this.state.step !== 4){
            this.getBackStep()
        }else if(this.props.children.props.mode==='cancel'&& this.state.step !==2 && this.state.step !== 3){
            this.getBackStep()
        }else{
            this.setState({ isOpen: false })
            if(this.state.closeall || amendcolse || cancelcolse){
                this.setState({closeall:false})
                this.props.removeprevChild()
            }
            setTimeout(() => {
                this.props.onClose()
            }, 300)
        }
    }

    componentDidMount() {
        if(this.props.children.props.mode==='reply' || this.props.children.props.mode==='cancel' || this.props.children.props.mode==='amend'){
            this.setState({step:2})
        }
        setTimeout(() => {
            this.setState({ isOpen: true })
        }, 0)
    }

    closeAllBox=(value)=>{
        this.setState({closeall:value})
    }

    getBackStep = () => {
        let { step ,fail} = this.state;
        if (this.props.clientID ) {
          switch (step) {
            case 2: {
              this.setState({ step: --step , fail: false })
              break
            }
            case 3: {
              this.setState({ fail: false , step: --step })
              break;
            }
            case 4: {
              this.setState({  step: --step })
              break;
            }
            default: {
              this.setState({ step: --step })
              break;
            }
          }
        } else {
    
        }
    
      }
    riseStep=()=>{
        this.setState({step:++this.state.step})
    }

    setStep=(step)=>{
        this.setState({step})
    }

    handleOpenCashDWenquiry=()=>{
        mobileSubLayoutAction.openCashDWenquiry()
    }

    handleOpenExchangeRecord = () => {
        mobileSubLayoutAction.openExchangeRecord()
    }
}

MobileSubLayout.defaultProps = {
    children: <div></div>,
    title: <div>Title</div>
}

export default connect(
    state => ({
        language: state.app.language,
        theme: state.app.theme,
        clientID: state.trade.clientID,
    })
)(MobileSubLayout)
